<template>
  <v-main :style="{ padding: $vuetify.breakpoint.smAndUp ? '0px 15%' : '' }">
    <v-tabs
      :value="currentStep"
      @change="setStep"
      color="#000B8D"
      :style="{ borderBottom: '1px solid #F2F2F2' }"
      centered
      grow
    >
      <v-tab
        v-for="(step, i) in steps"
        :key="i"
        :disabled="isTabDisabled(i)"
        :style="{ color: isStepComplete(i) ? 'green' : '' }"
        >{{ `Step ${i + 1}` }}
        <v-icon
          v-if="isStepComplete(i)"
          :style="{ marginLeft: '5px', color: 'green' }"
          small
          >fa-check-circle</v-icon
        ></v-tab
      >
    </v-tabs>

    <v-card
      :style="{
        marginTop: $vuetify.breakpoint.smAndUp ? '40px' : '',
        boxShadow: 'unset'
      }"
    >
      <template v-for="(step, n) of steps">
        <div
          class="rounded-lg"
          :style="{
            backgroundColor: '#F2F2F2',
            padding: $vuetify.breakpoint.lgAndUp ? '60px 100px' : '20px 20px'
          }"
          :key="n"
          v-if="currentStep === n"
        >
          <v-row>
            <v-col>
              <FormHeader :form="step" />

              <div @keyup.enter="() => onNextClicked(step)">
                <component
                  v-if="step.type === 'form'"
                  v-model="formData[step.id]"
                  :is="step.component"
                  :showErrors="showFormErrors"
                  :serverErrors="errors[step.id]"
                  :disabled="submitting"
                  @valid="valid => onValidChange(valid, step)"
                ></component>
                <Confirmation
                  v-else-if="step.type === 'confirmation'"
                  :data="formData"
                  :submitting="submitting"
                />
              </div>
            </v-col>
          </v-row>

          <v-row v-if="showFormErrors && !isFormValid(step)">
            <v-col>
              <span
                :style="{
                  color: '#FF0000',
                  font: 'normal normal 600 20px/30px Poppins'
                }"
              >
                Oops, please complete the required fields
              </span>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <NextBtn
                :disabled="submitting"
                :loading="submitting"
                v-if="currentStep < 3"
                @click="() => onNextClicked(step)"
                >Next</NextBtn
              >
              <NextBtn
                :disabled="submitting"
                :loading="submitting"
                v-else
                @click="() => submitForm()"
                :submit="true"
                >Send Request</NextBtn
              >
            </v-col>
          </v-row>
        </div>
      </template>
    </v-card>
  </v-main>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import _ from "lodash";
import httpService from "@/services/httpService";
import FormHeader from "@/components/FormHeader.vue";
import Form from "@/components/Form.vue";
import NextBtn from "@/components/NextBtn.vue";
import SampleDetailsForm from "@/components/forms/SampleDetails.vue";
import ShippingInformationForm from "@/components/forms/ShippingInformation.vue";
import ContactInformationForm from "@/components/forms/ContactInformation.vue";
import Confirmation from "@/components/Confirmation.vue";

//import { scrollToTop } from "@/utils";

export default {
  name: "Main",

  components: {
    Form,
    FormHeader,
    ContactInformationForm,
    SampleDetailsForm,
    ShippingInformationForm,
    NextBtn,
    Confirmation
  },

  data: () => ({
    enableTabs: false,

    formValid: {},
    errors: {
      contact_information: {
        // name: "Claude Abounegm"
      }
    },
    serverErrors: false,
    showFormErrors: false,
    submitting: false,

    formData: {
      contact_information: {
        // name: "Claude Abounegm",
        // email: "cabounegm@synapseresults.com",
        // company_name: "Synapse",
        // customer_name: "Test Customer"
      },
      sample_details: [
        // { quantity: 10, sku: "WT8-F-N1" },
        // { quantity: 6, sku: "SUSHI9LIDS" }
      ],
      shipping_information: {
        // name: "Claude Abounegm",
        // company: "Synapse",
        // email: "cabounegm@synapseresults.com",
        // phone: "(717) 892-4217",
        // address: "123 Test Ave",
        // city: "Lancaster",
        // state: "PA",
        // zip: "17601",
        // requested_arrival_date: undefined,

        country: "United States"
      }
    }
  }),

  mounted() {
    this.fetchProducts();
  },

  computed: {
    ...mapGetters("step", ["currentStep"]),

    steps() {
      return [
        {
          type: "form",
          id: "contact_information",
          title: "Your Contact Information",
          subTitle: "Enter your contact information.",
          component: "ContactInformationForm"
        },
        {
          type: "form",
          id: "sample_details",
          title: "Sample Details",
          subTitle: "Tell us the product samples you would like.",
          component: "SampleDetailsForm"
        },
        {
          type: "form",
          id: "shipping_information",
          title: "Shipping Information",
          subTitle: "Tell us where we should send these samples.",
          component: "ShippingInformationForm"
        },
        {
          type: "confirmation",
          id: "confirmation",
          title: "Confirmation",
          subTitle:
            "Please review this information for accuracy and click SEND REQUEST to order your samples."
        }
      ];
    }
  },
  methods: {
    ...mapActions("app", ["fetchProducts"]),
    ...mapMutations("app", ["setSubmitted"]),
    ...mapMutations("step", ["setStep", "goToNextStep"]),

    scrollToTop(scrollTo){
      if(scrollTo == undefined){
        scrollTo = document.getElementById('app').offsetTop;
      }
      window.scroll({
        top: scrollTo,
        left: 0,
        behavior: 'smooth'
      });
    },

    async onNextClicked(form) {
      this.submitting = true;

      try {
        if (this.isFormValid(form) || this.serverErrors) {
          this.showFormErrors = false;

          const res = await httpService.validateForm(
            form.id,
            this.formData[form.id]
          );

          this.$set(this.errors, form.id, res.invalidFields);
          this.serverErrors = !res.isValid;
          this.showFormErrors = !res.isValid;

          if (res.isValid) {
            this.goToNextStep();

            this.scrollToTop();
          }
        } else {
          this.showFormErrors = true;
        }
      } finally {
        this.submitting = false;
      }
    },

    isFormValid(form) {
      if (form.type === "form") {
        const valid = this.formValid[form.id];
        return valid;
      }

      return true;
    },

    isStepComplete(i) {
      const step = this.steps[i];

      if (step.type === "form") {
        return this.isFormValid(step);
      }

      if (
        this.currentStep === i &&
        step.type === "confirmation" &&
        this.submitting
      ) {
        return true;
      }

      return false;
    },

    isTabDisabled(i) {
      if (this.enableTabs) {
        return false;
      }

      if (this.submitting) {
        return true;
      }

      if (this.isStepComplete(i) && this.currentStep > i) {
        return false;
      }

      return this.currentStep !== i;
    },

    onValidChange(valid, form) {
      // console.log(valid, form);

      this.$set(this.formValid, form.id, valid);
    },

    async submitForm() {
      this.submitting = true;

      try {
        // console.log(JSON.stringify(this.formData));

        this.errors = {};
        await httpService.postFormData(this.formData);
        this.setSubmitted(true);
        this.scrollToTop(0);
      } catch (e) {
        const { data: errors } = e.response.data;

        if (errors) {
          this.errors = errors;
        }

        alert("An error has occured while submitting");
        // console.log(JSON.stringify(errors));
        this.submitting = false;
      }
    }
  }
  // watch: {
  //   formData: {
  //     deep: true,
  //     handler: v => console.log(JSON.stringify(v))
  //   }
  // }
};
</script>
